import type { ReactNode } from "react";

import { testLocator } from "@/lib/helpers/test-locator";
import { useMatchSupervisor } from "@/features/cosignature/hooks/useMatchSupervisor";
import { UUID } from "@/core/types";

import { supervisorSignature } from "../helpers/supervisor-signature";

import { NoteSignature } from "./NoteSignature";
import { ProviderSignature } from "./ProviderSignature";

type NoteCosignatureProps = {
  className?: string;
  cosignatureBadge?: ReactNode;
  cosignedBy?: UUID;
};

export function NoteCosignature({ cosignatureBadge, cosignedBy, ...props }: NoteCosignatureProps) {
  const { isLoading, supervisor } = useMatchSupervisor(cosignedBy);

  if (cosignatureBadge)
    return (
      <NoteCosignatureWrapper className="tw:items-start tw:gap-2" {...props}>
        {cosignatureBadge}
      </NoteCosignatureWrapper>
    );

  if (!cosignedBy) return null;

  return (
    <NoteCosignatureWrapper {...props} isLoading={isLoading}>
      {supervisor && (
        <ProviderSignature>
          {supervisorSignature({
            credentials: supervisor.credentials,
            name: supervisor.name,
          })}
        </ProviderSignature>
      )}
    </NoteCosignatureWrapper>
  );
}

type NoteCosignatureWrapperProps = NoteCosignatureProps & {
  children: ReactNode;
  isLoading?: boolean;
};

function NoteCosignatureWrapper(props: NoteCosignatureWrapperProps) {
  return <NoteSignature label="Co-signature" {...testLocator("coSignature")} {...props} />;
}
